var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M10 10.0852V18.125C9.89503 18.1246 9.79185 18.0977 9.7 18.0469L2.825 14.2828C2.72683 14.2291 2.64488 14.15 2.58772 14.0538C2.53055 13.9576 2.50025 13.8478 2.5 13.7359V6.26407C2.50025 6.17654 2.51888 6.09003 2.55469 6.01016L10 10.0852Z",
    fill: "#7F8080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.475 5.16798L10.6 1.40626C10.4163 1.30477 10.2099 1.25153 10 1.25153C9.79013 1.25153 9.58369 1.30477 9.4 1.40626L2.525 5.16955C2.32866 5.27697 2.16477 5.43514 2.05043 5.62753C1.93609 5.81993 1.87551 6.03949 1.875 6.2633V13.7352C1.87551 13.959 1.93609 14.1785 2.05043 14.3709C2.16477 14.5633 2.32866 14.7215 2.525 14.8289L9.4 18.5922C9.58369 18.6937 9.79013 18.7469 10 18.7469C10.2099 18.7469 10.4163 18.6937 10.6 18.5922L17.475 14.8289C17.6713 14.7215 17.8352 14.5633 17.9496 14.3709C18.0639 14.1785 18.1245 13.959 18.125 13.7352V6.26408C18.1249 6.03987 18.0645 5.81982 17.9502 5.62698C17.8358 5.43414 17.6717 5.2756 17.475 5.16798ZM10 2.50001L16.2766 5.93751L13.9508 7.21095L7.67344 3.77345L10 2.50001ZM10 9.37501L3.72344 5.93751L6.37187 4.48751L12.6484 7.92501L10 9.37501ZM3.125 7.03126L9.375 10.4516V17.1539L3.125 13.736V7.03126ZM16.875 13.7328L10.625 17.1539V10.4547L13.125 9.08673V11.875C13.125 12.0408 13.1908 12.1997 13.3081 12.317C13.4253 12.4342 13.5842 12.5 13.75 12.5C13.9158 12.5 14.0747 12.4342 14.1919 12.317C14.3092 12.1997 14.375 12.0408 14.375 11.875V8.40236L16.875 7.03126V13.732V13.7328Z",
    fill: "#7F8080"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/Products.8476e7e9.svg";
export { ForwardRef as ReactComponent };